// extracted by mini-css-extract-plugin
module.exports =  {"mdx":"VZgchPH2t4Qf9yrH2Ehx"};